import React, { Component } from 'react';
import SketchPicker from 'react-color/lib/components/sketch/Sketch';
import styles from './watermark.module.scss';

export default class ColorPicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayColorPicker: false,
      color: props.color,
      background: props.color,
      disabled: props.disabled || false,
      rgba: null,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.color !== prevProps.color) {
      const { color } = this.props;
      this.setState({ color, background: color });
    }
  }

  handleClose = () => {
    this.setState({ displayColorPicker: false });
    // notify
    this.props.onChangeComplete({ ...this.state });
  };
  handleChange = (color) => {
    this.setState({ color: color.hex, rgba: color.rgb });
  };
  handleChangeComplete = (color) => {
    this.setState({ background: color.hex, rgba: color.rgb });
  };
  handleClick = () => {
    if (!!this.props.disabled) {
      return;
    }
    this.setState({ displayColorPicker: !this.state.displayColorPicker });
  };

  render() {
    //const { disabled } = this.props;
    const { PickerStyle, disableAlpha = false } = this.props;
    let btnColor = {
      width: '24px',
      height: '24px',
      borderRadius: '2px',
      background: this.state.color,
    };
    return (
      <div className='color-picker inline w-24 h-24'>
        <div className={styles.swatch}>
          {/* <div hidden={!disabled} className={styles.disabledColor}></div>   */}
          <div style={btnColor} onClick={this.handleClick}></div>
        </div>
        {!!this.state.displayColorPicker &&
          <div className={styles.popover}
               style={!!PickerStyle ? { ...PickerStyle } : {}}>
            <div className={styles.cover} onClick={this.handleClose} />
            <SketchPicker color={this.state.color}
                          onChange={this.handleChange}
                          onChangeComplete={this.handleChangeComplete}
                          disableAlpha={disableAlpha}
            />
          </div>
        }
      </div>
    );
  }
}
